import React from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useParams, Redirect } from "react-router-dom";
import TERMS from "../../data/terms";
import LogoLayout from "../../components/LogoLayout";

const Terms = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { healthFacilityId } = useParams()

  if (!healthFacilityId || !TERMS[healthFacilityId]) {
    return <Redirect to="/" />;
  }

  const terms = TERMS[healthFacilityId];

  return (
    <LogoLayout
      logo={terms.logo}
      containerSize="md"
    >
      <Grid
        container
        direction={isMobile ? "column" : "row"}
        justifyContent="flex-start"
        alignItems={isMobile ? "flex-start" : "center"}
        sx={{
          marginBottom: isMobile ? "24px" : "12px",
        }}
      >
        <Box mr={3}>
          <Typography variant="h1" sx={{ textTransform: "capitalize" }}>
            {terms.title}
          </Typography>
        </Box>
      </Grid>
      <Box>
        <Card
          sx={(_theme) => ({
          borderRadius: "8px",
          padding: "26px",
          boxShadow: "0px 4px 8px rgba(102, 109, 146, 0.08)",
          [_theme.breakpoints.down("md")]: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        })}
          width="100%"
        >
          <CardContent style={{ padding: "16px" }}>
            {terms.content}
          </CardContent>
        </Card>
      </Box>
    </LogoLayout>
  );
};
 
export default Terms;
